export const isMimeType = (value: string) => {
  const validMIMETypeRegex =
    /^(application|audio|font|example|image|message|model|multipart|text|video)\/[\w.+-]+$/;
  return (
    value === 'audio/*' ||
    value === 'video/*' ||
    value === 'image/*' ||
    value === 'text/*' ||
    validMIMETypeRegex.test(value)
  );
};
